import {
  vs2jen2GlobalReleaseConstants,
  addVs2jen2GlobalReleaseConstants,
  editVs2jen2GlobalReleaseConstants,
} from "../_redux-constants";
import { vs2jen2GlobalReleaseService } from "../../_services";

function getVs2jen2GlobalRelease() {
  function getVs2jen2GlobalReleaseLoad() {
    return {
      type: vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_LOADING,
    };
  }
  function getVs2jen2GlobalReleaseSuccess(data) {
    return {
      type: vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getVs2jen2GlobalReleaseFailure(error) {
    return {
      type: vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2jen2GlobalReleaseLoad());
    return vs2jen2GlobalReleaseService.getVs2jen2GlobalRelease().then(
      (data) => {
        dispatch(getVs2jen2GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getVs2jen2GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addVs2jen2GlobalRelease(formData) {
  function addVs2jen2GlobalReleaseLoad() {
    return {
      type: addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_LOADING,
    };
  }
  function addVs2jen2GlobalReleaseSuccess(data) {
    return {
      type: addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addVs2jen2GlobalReleaseFailure(error) {
    return {
      type: addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addVs2jen2GlobalReleaseLoad());
    return vs2jen2GlobalReleaseService.addVs2jen2GlobalRelease(formData).then(
      (data) => {
        dispatch(addVs2jen2GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addVs2jen2GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editVs2jen2GlobalRelease(formData) {
  function editVs2jen2GlobalReleaseLoad() {
    return {
      type: editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_LOADING,
    };
  }
  function editVs2jen2GlobalReleaseSuccess(data) {
    return {
      type: editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editVs2jen2GlobalReleaseFailure(error) {
    return {
      type: editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editVs2jen2GlobalReleaseLoad());
    return vs2jen2GlobalReleaseService.editVs2jen2GlobalRelease(formData).then(
      (data) => {
        dispatch(editVs2jen2GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editVs2jen2GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const vs2jen2GlobalReleaseActions = {
  getVs2jen2GlobalRelease,
  addVs2jen2GlobalRelease,
  editVs2jen2GlobalRelease,
};
